import React from 'react';
import ListValidationError from '@/components/errors/ListValidationError';
import FormTextArray from './FormTextArray';
import FormStringLinksDescription from './FormStringLinksDescription';
import FormPhone from './FormPhone';
import FormItemDescription from './FormItemDescription';
import FormStringsDescription from './FormStringsDescription';
import FormDate from './FormDate';
import FormTextArea from './FormTextArea';
import FormInput from './FormInput';
import FormMarkdown from './FormMarkdown';
import FormToggle from './FormToggle';
import FormNumber from './FormNumber';
import FormUrl from './FormUrl';
import FormDropdown from './FormDropdown';
import FormMultiDropdown from './FormMultiDropdown';
import FormLabel from './FormLabel';
import FormBooleanDescription from './FormBooleanDescription';
import FormUuid from './FormUuid';
import FormListDescription from './FormListDescription';
import FormAuth from '../auth/components/FormAuth';

export const formFieldComponents = {
  auth: { editor: FormAuth, component: FormItemDescription, hasLabel: false },
  boolean: { editor: FormToggle, component: FormBooleanDescription, hasLabel: false },
  date: { editor: FormDate, component: FormItemDescription, hasLabel: true },
  email: { editor: FormInput, component: FormItemDescription, hasLabel: true },
  emails: { editor: FormTextArray, component: FormStringLinksDescription, hasLabel: true },
  label: { editor: FormLabel, component: FormLabel, hasLabel: false },
  list: { editor: FormDropdown, component: FormListDescription, hasLabel: true },
  // markdowns: { component: FormInput, hasLabel: true },
  markdown: { editor: FormMarkdown, component: FormItemDescription, hasLabel: true },
  number: { editor: FormNumber, component: FormItemDescription, hasLabel: true },
  phone: { editor: FormPhone, component: FormItemDescription, hasLabel: true },
  string: { editor: FormInput, component: FormItemDescription, hasLabel: true },
  strings: { editor: FormMultiDropdown, component: FormStringsDescription, hasLabel: true },
  text: { editor: FormTextArea, component: FormItemDescription, hasLabel: true },
  // texts: { component: FormInput, hasLabel: true },
  uri: { editor: FormUrl, component: FormItemDescription, hasLabel: true },
  uris: { editor: FormTextArray, component: FormStringLinksDescription, hasLabel: true },
  uuid: { editor: FormUuid, component: FormItemDescription, hasLabel: true },
  uuids: { editor: FormTextArray, component: FormStringsDescription, hasLabel: true },
};

const FormListItemContainer = ({
  children,
  field,
  hideLabel,
  hasLabel,
  isEditing,
  error,
}) => (
  <>
    {hasLabel && !hideLabel && (
      <ListValidationError
        labelText={field.validation?.required && isEditing ? `${field.label} *` : field.label}
        error={isEditing ? error : undefined}
      />
    )}
    {!isEditing && (children)}
  </>
);

export default FormListItemContainer;
